import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type PostponedLetterRequestsQueryVariables = Types.Exact<{ [key: string]: never }>

export type PostponedLetterRequestsQuery = {
  __typename?: 'Query'
  postponedRequestsForLawyer: Array<{
    __typename?: 'LetterRequest'
    id: number
    canceledOn?: any | null
    createdAt: any
    customer: {
      __typename?: 'Customer'
      id: number
      firstName?: string | null
      lastName?: string | null
    }
    powerOfAttorney?: {
      __typename?: 'PowerOfAttorney'
      uid: string
      deliveryMethod: Types.DeliveryMethod
      state: Types.PowerOfAttorneyState
      customerDocument?: { __typename?: 'CustomerDocument'; id: number; createdAt: any } | null
    } | null
    question: {
      __typename?: 'Message'
      id: number
      topic: { __typename?: 'Topic'; id: number; name: string }
    }
  }>
}

export const PostponedLetterRequestsDocument = gql`
  query PostponedLetterRequests {
    postponedRequestsForLawyer {
      id
      canceledOn
      createdAt
      customer {
        id
        firstName
        lastName
      }
      powerOfAttorney {
        uid
        deliveryMethod
        state
        customerDocument {
          id
          createdAt
        }
      }
      question {
        id
        topic {
          id
          name
        }
      }
    }
  }
`
export function usePostponedLetterRequestsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PostponedLetterRequestsQuery,
    PostponedLetterRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PostponedLetterRequestsQuery,
    PostponedLetterRequestsQueryVariables
  >(PostponedLetterRequestsDocument, options)
}
export function usePostponedLetterRequestsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PostponedLetterRequestsQuery,
    PostponedLetterRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PostponedLetterRequestsQuery,
    PostponedLetterRequestsQueryVariables
  >(PostponedLetterRequestsDocument, options)
}
export type PostponedLetterRequestsQueryHookResult = ReturnType<
  typeof usePostponedLetterRequestsQuery
>
export type PostponedLetterRequestsLazyQueryHookResult = ReturnType<
  typeof usePostponedLetterRequestsLazyQuery
>
export type PostponedLetterRequestsQueryResult = ApolloReactCommon.QueryResult<
  PostponedLetterRequestsQuery,
  PostponedLetterRequestsQueryVariables
>
export function refetchPostponedLetterRequestsQuery(
  variables?: PostponedLetterRequestsQueryVariables
) {
  return { query: PostponedLetterRequestsDocument, variables: variables }
}
